import React from 'react';

import { Col, Form, Spinner } from 'react-bootstrap';

import './styles.scoped.css';

const InputBox = ({
  colStyle,
  title,
  error,
  errorMessage,
  style,
  span = false,
  value,
  disabled,
  loading = false,
  type = 'text',
  ...rest
}) => (
  <div style={{ ...style }}>
    <Col style={{ ...colStyle }}>
      {!!title && (
        <Form.Label>
          {title} {span && <span className="required">*</span>}
        </Form.Label>
      )}
      <div style={{ height: 45 }}>
        {loading ? (
          <Spinner animation="border" size="sm" />
        ) : (
          <Form.Control value={value} disabled={disabled} {...rest} style={{ borderColor: 'black' }} type={type} />
        )}
      </div>
      {error && errorMessage && <span className="error-message">{errorMessage}</span>}
    </Col>
  </div>
);

export default InputBox;
